import { generateMedia } from 'styled-media-query';

export const BREAK_POINT = {
  XS: '478px',
  SM: '767px',
  MD: '991px',
  LG: '1280px',
  XL: '1440px',
  XXL: '1920px',
};

export const media = generateMedia({
  xs: BREAK_POINT.XS,
  sm: BREAK_POINT.SM,
  md: BREAK_POINT.MD,
  lg: BREAK_POINT.LG,
  xl: BREAK_POINT.XL,
  xxl: BREAK_POINT.XXL,
});
